"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /Users/clementinefernandez/Local Sites/imatag/app/public/wp-content/themes/www/node_modules/youtube-player/dist/constants/PlayerStates.js
// module id = 122
// module chunks = 0